export const MOBILE_VIEWPORT = "700";
